interface DepartmentEndpoints {
  LIST: (orgId: string) => string;
  CREATE: (orgId: string) => string;
  DETAIL: (orgId: string, deptId: string) => string;
  UPDATE: (orgId: string, deptId: string) => string;
  DELETE: (orgId: string, deptId: string) => string;
  MEMBERS: {
    LIST: (orgId: string, deptId: string) => string;
  };
}

export const departmentEndpoints: DepartmentEndpoints = {
  LIST: (orgId: string) => `/api/organizations/${orgId}/departments/`,
  CREATE: (orgId: string) => `/api/organizations/${orgId}/departments/`,
  DETAIL: (orgId: string, deptId: string) =>
    `/api/organizations/${orgId}/departments/${deptId}/`,
  UPDATE: (orgId: string, deptId: string) =>
    `/api/organizations/${orgId}/departments/${deptId}/`,
  DELETE: (orgId: string, deptId: string) =>
    `/api/organizations/${orgId}/departments/${deptId}/`,
  MEMBERS: {
    LIST: (orgId: string, deptId: string) =>
      `/api/organizations/${orgId}/departments/${deptId}/members/`,
  },
};
